import api from "!../../../../.yarn/__virtual__/style-loader-virtual-c5f3ab1a97/11/root/.yarn/berry/cache/style-loader-npm-2.0.0-b9a5c4a2aa-10c0.zip/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../.yarn/__virtual__/css-loader-virtual-233e5da201/11/root/.yarn/berry/cache/css-loader-npm-5.2.7-e1e8b8d16f-10c0.zip/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!../../../../.yarn/__virtual__/postcss-loader-virtual-16a453451f/11/root/.yarn/berry/cache/postcss-loader-npm-4.3.0-3e7af086e3-10c0.zip/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[4].use[2]!../../../../.yarn/__virtual__/sass-loader-virtual-11f0f45fc1/11/root/.yarn/berry/cache/sass-loader-npm-10.5.2-d5bec31fb8-10c0.zip/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[4].use[3]!./_print.pageWrapper.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};